import React, {memo} from 'react';

import {SearchSummaryFields} from '../SearchSummaryFields/SearchSummaryFields';
import {SearchDetailsModal} from '../SearchDetailsModal/SearchDetailsModal';
import {SearchDetailsFields} from '../SearchDetailsFields/SearchDetailsFields';

import {useComponent} from './hooks/useComponent';

import './SearchForm.less';

import '../SearchFields/SearchFields.less';
import '../SearchField/SearchField.less';
import '../SearchInputField/SearchInputField.less';
import '../SearchButtonField/SearchButtonField.less';
import '../SearchModal/SearchModal.less';

const SearchForm = memo(function SearchForm(props) {
    const {
        className,
        showSummary,
        onSubmit
    } = useComponent(props);

    return (
        <form className={className} onSubmit={onSubmit}>
            {showSummary ? (
                <>
                    <SearchSummaryFields/>
                    <SearchDetailsModal/>
                </>
            ) : (
                <SearchDetailsFields/>
            )}
        </form>
    );
});

SearchForm.whyDidYouRender = true;

export default SearchForm;
export {SearchForm};
